/**
 * Message éphémère en bas d'écran (confirmations du panneau de debug, refus
 * d'Invasion anticipée…). Un seul à la fois : le nouveau remplace l'ancien.
 *
 * v0.14.0 : composant facetté de la charte F1 (`.toast` dans `src/style.css`),
 * avec une icône facultative du jeu (`ui/icons.ts`) devant le texte.
 */
import { overlayRoot } from './columnScale';
import { icon as iconSvg, type IconName } from './icons';

let current: HTMLElement | null = null;
let timer: number | undefined;

export function toast(message: string, ms = 2200, icon?: IconName): void {
  if (typeof document === 'undefined') return;
  current?.remove();
  if (timer !== undefined) window.clearTimeout(timer);

  const el = document.createElement('div');
  el.className = 'toast';
  el.setAttribute('role', 'status');
  if (icon) {
    el.innerHTML = iconSvg(icon);
    const text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);
  } else {
    el.textContent = message;
  }
  overlayRoot().appendChild(el);
  current = el;

  timer = window.setTimeout(() => {
    el.remove();
    if (current === el) current = null;
  }, ms);
}
